export default "__VITE_ASSET__ca7ebd41__"